export default __webpack_public_path__ + "static/AiDevZone-6d89a4fddd1e69f7021dc0cd963e7de5.png";